module.exports = __webpack_public_path__ + "static/media/hillshade.fragment.0d0701a1.glsl";